import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { LogOut, LayoutDashboard, Shield, UtensilsCrossed, FileText, DollarSign } from 'lucide-react';
import { useAdminNotifications } from '@/hooks/useAdminNotifications';

export default function Header() {
  const { currentUser, userProfile, logout } = useAuth();
  const navigate = useNavigate();
  const adminNotifications = useAdminNotifications(!!userProfile?.isAdmin);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <header className="admin-header border-b">
      <div className="container mx-auto flex items-center justify-between px-4 py-4">
        <Link to={currentUser ? '/dashboard' : '/login'} className="flex items-center space-x-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-admin-accent">
            <Shield className="h-6 w-6 text-white" />
          </div>
          <div>
            <span className="text-xl font-bold text-foreground">Admin Panel</span>
          </div>
        </Link>

        <div className="flex items-center space-x-4">
          {currentUser && userProfile?.isAdmin ? (
            <>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => window.open(import.meta.env.VITE_DINING_URL || 'http://localhost:3000', '_blank')}
                title="Dining"
                className="flex items-center gap-2"
              >
                <UtensilsCrossed className="h-4 w-4" />
                <span className="hidden sm:inline">Dining</span>
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => window.open(import.meta.env.VITE_SECRETARY_URL || 'http://localhost:3001', '_blank')}
                title="Secretary"
                className="flex items-center gap-2"
              >
                <FileText className="h-4 w-4" />
                <span className="hidden sm:inline">Secretary</span>
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => window.open(import.meta.env.VITE_TREASURER_URL || 'http://localhost:3002', '_blank')}
                title="Treasurer"
                className="flex items-center gap-2"
              >
                <DollarSign className="h-4 w-4" />
                <span className="hidden sm:inline">Treasurer</span>
              </Button>
              <div className="mx-2 h-6 w-px bg-border" />
              <Button
                variant="ghost"
                size="icon"
                onClick={() => navigate('/dashboard')}
                title="Dashboard"
                className="relative"
              >
                <LayoutDashboard className="h-5 w-5" />
                {adminNotifications.total > 0 && (
                  <Badge 
                    variant="destructive" 
                    className="absolute -top-1 -right-1 h-5 w-5 p-0 flex items-center justify-center text-[10px]"
                  >
                    {adminNotifications.total > 9 ? '9+' : adminNotifications.total}
                  </Badge>
                )}
              </Button>
              <Button variant="ghost" size="icon" onClick={handleLogout} title="Logout">
                <LogOut className="h-5 w-5" />
              </Button>
            </>
          ) : null}
        </div>
      </div>
    </header>
  );
}

